<!-- Header -->
@if(bulkEditAuthorFacade.selectType$ | async; as selectType) {
  @let slideBulkEditItemCount = (bulkEditAuthorFacade.slideBulkEditItemCount$ | async) || 0;
  <medsurf-slide-edit-header
    [icon]="FlatModels.BulkEditAuthorModels.BulkEditEntityTypeIcon[selectType]"
    [label]="(slideBulkEditItemCount === 1 ? 'global.selection_description_singular' : 'global.selection_description_plural') | translate: {count: slideBulkEditItemCount}"
  [type]="FlatModels.BulkEditAuthorModels.BulkEditEntityTypeDescription[selectType] || ''"></medsurf-slide-edit-header>
}

<!-- Content -->
